var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"group-detail"},[_c('SettingForm',{on:{"getAttachment":_vm.getAttachment}}),_c('Iphone',{staticClass:"iphone",attrs:{"attachment":_vm.attachment}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }